import { StylesConfig } from "react-select";

export const customStyles: StylesConfig<OptionType, false> = {
    control: (provided, state) => ({
        ...provided,
        border: `1px solid ${state.isFocused ? '#0747a6' : '#DADBDD'}`,
        boxShadow: state.isFocused ? '0 0 0 1px #0747a6' : 'none',
        '&:hover': {
            border: `1px solid ${state.isFocused ? '#0747a6' : '#DADBDD'}`
        }
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#0747a6' : state.isFocused ? '#F4F5F7' : 'white',
        color: state.isSelected ? 'white' : '#172B4D',
        '&:hover': {
            backgroundColor: state.isSelected ? '#0747a6' : '#F4F5F7'
        }
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999
    })
};